const _Optional = class _Optional {
  constructor(value) {
    this.value = value;
  }
  static ofNullable(value) {
    return value == null ? _Optional.empty() : _Optional.of(value);
  }
  static of(value) {
    return new _Optional(value);
  }
  orElse(other) {
    const val = this.isPresent() ? this.value : other;
    return val;
  }
  isPresent() {
    return this.value != null && this.value != void 0;
  }
  // public ifPresent<T>(Consumer<? super T> consumer) {
  // if (value != null)
  // consumer.accept(value);
  // }
  static empty() {
    return _Optional.EMPTY;
  }
  // public static default<T>(value: any, def: T): T {
  //     return (value != null && value != undefined) ? value : def;
  // }
};
_Optional.EMPTY = new _Optional();
let Optional = _Optional;
export {
  Optional
};
//# sourceMappingURL=Optional.js.map
